import { inject, observer } from 'mobx-react';
import React from 'react';
import { ModuleContainer, ModuleDescription, ModuleIndex, ModuleTitle } from '../parts';
import PathIcon from '../PathIcon';
import ProgressEnum from '../../../../../models/learning/ProgressEnum';
import surveyImg from '../../../../../images/survey.svg';

const Survey = ({ learningId, pathId, icon, module, elective, disabled, learningStore }) => {
  const active = module.progress === ProgressEnum.InProgress || module.progress === ProgressEnum.Completed;

  const renderSurveyIndex = () => (
    <div className="flex justify-between">
      <ModuleIndex className={`${active ? 'active' : ''}`}>
        {(module.index + 1).toString().padStart(2, '0')}
      </ModuleIndex>
      <PathIcon icon={icon} active={active} />
    </div>
  );

  const renderActionButton = () => {
    const handleFeedbackClick = () => {
      const url = `/learn/${learningId}/path/${pathId}/${module.id}/survey`;

      // Open first, synchronously. Browsers only allow a popup while the click is still on the
      // stack, so awaiting the call below first gets the tab blocked and window.open returns null.
      const surveyTab = window.open(url, '_blank');
      if (surveyTab) surveyTab.focus();

      if (module.progress === ProgressEnum.NotStarted) {
        // Fire and forget: `module.progress` comes from a cached snapshot and can still read
        // NotStarted after the survey was already opened once, in which case the server rejects
        // this as already started. Either way it must not affect opening the survey.
        Promise.resolve(learningStore.startUserLearningModule(learningId, pathId, module.id)).catch(() => {});
      }

      // Popups blocked entirely (browser setting or shield): fall back to this tab rather than
      // leaving the click doing nothing.
      if (!surveyTab) window.location.assign(url);
    };

    if (!module.enable)
      return (
        <button type="button" className="primary-black disabled">
          Coming Soon
        </button>
      );
    const completed = module.progress === ProgressEnum.Completed;
    return (
      <button
        type="button"
        className={`primary-black ${disabled || completed ? 'disabled' : ''}`}
        onClick={handleFeedbackClick}
      >
        <span role="img" aria-label="survey">
          {completed ? '✓' : '📝'}
        </span>{' '}
        {completed ? 'Completed' : 'Take survey'}
      </button>
    );
  };

  return (
    <ModuleContainer className="p3">
      {!elective ? renderSurveyIndex() : ''}
      <div>
        <ModuleTitle>{module.name || 'Milestone check-in: How do you feel?'}</ModuleTitle>
        <ModuleDescription>{module.description}</ModuleDescription>
      </div>
      <img src={surveyImg} alt="survey" className="my3 fit" />

      <div className="flex justify-between mxn2 custom-actions">
        <div className="col-12 px2">{renderActionButton()}</div>
      </div>
    </ModuleContainer>
  );
};

export default inject('learningStore')(observer(Survey));
